import { useEffect } from "react";
import Hero from "@/components/sections/Hero";
import TrustStrip from "@/components/sections/TrustStrip";
import ProductGrid from "@/components/sections/ProductGrid";
import UpgradeForm from "@/components/sections/UpgradeForm";
import FeatureGrid from "@/components/sections/FeatureGrid";
import UseCases from "@/components/sections/UseCases";
import CompareTable from "@/components/sections/CompareTable";
import Clinics from "@/components/sections/Clinics";
import Testimonials from "@/components/sections/Testimonials";
import VideoSection from "@/components/sections/VideoSection";
import FAQ from "@/components/sections/FAQ";
import QuickStart from "@/components/sections/QuickStart";
import SixReasons from "@/components/SixReasons";
import Seo, { orgSchema, faqSchema } from "@/components/Seo";

const HOME_FAQS = [
    { q: "What is the price of Signia Styletto IX in India?", a: "Signia Styletto IX starts at ₹1,49,990 (1IX pair) and goes up to ₹7,24,990 (7IX flagship pair). No-Cost EMI from ₹12,500/month on all major credit cards (6-24 months)." },
    { q: "What is RealTime Conversation Enhancement in Signia Styletto IX?", a: "RealTime Conversation Enhancement (RTCE) is the flagship feature of the Signia Integrated Xperience (IX) platform. It uses AI to identify who is speaking in a group and steer amplification to the active speaker in real time — clinically shown to outperform four top competitor hearing-aid platforms in noisy group settings (Jensen et al., 2023)." },
    { q: "Where can I buy genuine Signia Styletto IX in India?", a: "Through signiastylettoix.com — a Signia Certified Partner store powered by HearClear. Devices ship pan-India with free doorstep fitting by a licensed audiologist and are backed by full Signia India warranty (3-year on 1IX/2IX/3IX; 4-year on 5IX/7IX)." },
    { q: "Can I trial Styletto IX before buying?", a: "Yes — a 3-day risk-free trial is available at home or at any HearClear clinic across 195+ cities, with a full refund if you don't love it." },
    { q: "Is EMI available on Signia Styletto IX?", a: "Yes — No-Cost EMI on eligible HDFC, ICICI, Axis, SBI, Kotak and AmEx credit cards. EMI plans from ₹12,500/month for 6, 9, 12, 18 or 24 months." },
    { q: "Does Signia Styletto IX support Bluetooth streaming?", a: "Yes — full Bluetooth streaming to iPhone (Made-for-iPhone / MFi) and Android (ASHA). Hands-free calling on iPhone. Ready for LE Audio via future firmware update." },
    { q: "How does the Signia app work with Styletto IX?", a: "The Signia app lets you fine-tune programs, remote-control volume, stream TV/music, and chat with Signia Assistant (an AI helper) for on-the-fly adjustments. My WellBeing tracks daily activity from the hearing aid's motion sensors." },
    { q: "Is Styletto IX rechargeable? How long does the battery last?", a: "Yes — lithium-ion rechargeable with 17-20 hours per full charge (including streaming). The pocket-sized wireless charging case adds up to 5 additional full charges — ideal for travel." },
];

export default function Home() {
    useEffect(() => {
        document.title = "Signia Styletto IX — Slim & Stylish Rechargeable RIC Hearing Aids | signiastylettoix.com";
    }, []);
    const schema = {
        "@context": "https://schema.org",
        "@graph": [orgSchema(), faqSchema(HOME_FAQS)],
    };
    return (
        <>
            <Seo
                title="Signia Styletto IX — Slim & Stylish Rechargeable RIC Hearing Aids | signiastylettoix.com"
                description="Signia Styletto IX (1IX · 2IX · 3IX · 5IX · 7IX) — ultra-slim SlimRIC hearing aids with RealTime Conversation Enhancement, all-day rechargeable battery, iPhone (MFi) & Android (ASHA) Bluetooth streaming, LE Audio ready. From ₹1,49,990. Free 3-day trial · No-Cost EMI · Signia Certified Partner. Powered by HearClear."
                canonical="https://signiastylettoix.com/"
                schema={schema}
            />
            <Hero />
            <QuickStart />
            <TrustStrip />
            <ProductGrid limit={6} />
            <SixReasons />
            <UpgradeForm />
            <FeatureGrid />
            <VideoSection />
            <UseCases />
            <CompareTable />
            <Clinics limit={8} />
            <Testimonials />
            <FAQ limit={12} />
        </>
    );
}
